import { createStore } from 'vuex';
import State from '@/types/State';

import * as Actions from './actions';

export default createStore({
  state() {
    return {
      campaign: null,
      yourdata: null,
      employeeID: null,
      token: '',
      appointmentRegistered: false,
      hasAccountAtMep: false,
    };
  },
  mutations: {
    SET_SELECTED_CAMPAIGN: (state: State, campaign) => {
      state.campaign = campaign;
    },

    SET_YOURDATA: (state: State, yourData) => {
      state.yourdata = yourData;
    },

    SET_EMPLOYEEID: (state: State, employeeID) => {
      state.employeeID = employeeID;
    },

    SET_TOKEN: (state: State, token) => {
      state.token = token;
    },

    SET_APPOINTMENT_REGISTERED_FLAG: (state: State, isRegistered: boolean) => {
      state.appointmentRegistered = isRegistered;
    },

    SET_HAS_ACCOUNT_AT_MEP_FLAG: (state: State, hasAccountAtMep: boolean) => {
      state.hasAccountAtMep = hasAccountAtMep;
    },

  },
  actions: {
    [Actions.SET_SELECTED_CAMPAIGN]: ({ commit }, campaign) => {
      commit('SET_SELECTED_CAMPAIGN', campaign);
    },

    [Actions.SET_YOURDATA]: ({ commit }, yourData) => {
      commit('SET_YOURDATA', yourData);
    },

    [Actions.SET_EMPLOYEEID]: ({ commit }, employeeID) => {
      commit('SET_EMPLOYEEID', employeeID);
    },

    [Actions.SET_TOKEN]: ({ commit }, token) => {
      commit('SET_TOKEN', token);
    },

    [Actions.SET_APPOINTMENT_REGISTERED_FLAG]: ({ commit }, isRegistered: boolean) => {
      commit('SET_APPOINTMENT_REGISTERED_FLAG', isRegistered);
    },

    [Actions.SET_HAS_ACCOUNT_AT_MEP_FLAG]: ({ commit }, hasAccountAtMep: boolean) => {
      commit('SET_HAS_ACCOUNT_AT_MEP_FLAG', hasAccountAtMep);
    },
  },
  modules: {},
});
